<template>
  <div>
    <h1>404 - 页面未找到</h1>
    <p>很抱歉，你访问的页面不存在。</p>
  </div>
</template>

<script>
export default {
  // 组件逻辑
};
</script>
